module.exports = __webpack_public_path__ + "media/images/backgrounds/banner_bg-90cca8abf568f1a7d11c26b94a25e356.png";